import { useEffect } from "react";

const useDeviceRedirect = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent
      );
    const currentURL = window.location.href;
    const webURL = process.env.REACT_APP_WEB_PUBLIC_PATH;

    if (!isMobile && !currentURL.includes(webURL)) {
      window.location.href = webURL;
    }
  }, []);
};

export default useDeviceRedirect;
